import { ProgressBar, Text } from '@change/ds-core-ui';
import { FlagIcon } from '@change/ds-icons';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

type Props = {
	signatureCount: number;
	nextMilestone: number;
};

export const SignatureThermometer = ({ signatureCount, nextMilestone }: Props): JSX.Element | null => {
	const { translate } = useI18n();

	if (!nextMilestone) return null;

	return (
		<div data-testid="signature-thermometer-container" className="rounded-md flex flex-col gap-2">
			<div className="flex gap-2">
				<div className="bg-fill-information-weaker flex h-6 w-6 rounded-[12px] p-1">
					<FlagIcon size={14} data-testid="signatures-milestone-flag-icon" className="text-icon-information" />
				</div>
				<Text size="small" fontWeight="bold">
					<Translate
						value="corgi.petition_gamma.details.signature_thermometer.title"
						replacements={{ nextMilestone }}
					/>
				</Text>
			</div>

			<ProgressBar
				ariaLabel={translate('corgi.petition_gamma.details.signature_thermometer.title', { nextMilestone })}
				percentage={Math.floor((signatureCount / nextMilestone) * 100)}
				size="small"
			/>

			<Text size="small">
				<Translate value="corgi.petition_gamma.details.signature_thermometer.body" />
			</Text>
		</div>
	);
};
